<template>
    <app-modal-prompt 
        :value="value"
        :loading="loading" 
        @input="e => $emit('input', e)" 
        @confirm="$emit('update', { 'show': show_copy, 'hide': hide_copy })"
        @cancel="$emit('cancel')"
        :width="width"
    >
        <template #title>
            {{title}}
        </template>
        <template>
            <app-modal-container>
                <app-modal-row v-if="$slots.top_actions">
                  <app-modal-col cols="12">
                    <slot name="top_actions"></slot>
                  </app-modal-col>
                </app-modal-row>
                <app-modal-row>
                    <app-modal-col cols="12" sm="6"  >
                        <v-list dense class="py-0">
                            <v-subheader class="text-color">
                                {{ show_columns_header }}
                            </v-subheader>
                            <draggable
                                v-model="show_copy"
                                :options="{ group: 'people' }"
                                style="min-height: 10px"
                                class="y-scroll"
                            >
                                <template v-for="item, index in show_copy">
                                    <v-list-item :key="item.value" class="draggable-item">
                                        <v-list-item-content>
                                            <v-list-item-title
                                                class="text-color"
                                                v-text="(index+1) + '. ' + item.text"
                                            ></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </draggable>
                        </v-list>
                    </app-modal-col>
                    <app-modal-col cols="12" sm="6"  >
                        <v-list dense class="py-0">
                            <v-subheader class="text-color">
                                {{ hide_columns_header }}
                            </v-subheader>
                            <draggable
                                v-model="hide_copy"
                                :options="{ group: 'people' }"
                                style="min-height: 10px"
                                class="y-scroll"
                            >
                                <template v-for="item in hide_copy">
                                    <v-list-item :key="item.value" class="draggable-item">
                                        <v-list-item-content>
                                            <v-list-item-title
                                                class="text-color"
                                                v-text="item.text"
                                            ></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </draggable>
                        </v-list>
                    </app-modal-col>
                </app-modal-row>
            </app-modal-container>
        </template>    
    </app-modal-prompt>
</template>

<script>
import draggable from "vuedraggable";
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';

export default {
    name: 'DraggableShowHideDialog',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: false,
        },
        show_columns_header: {
            type: String,
            required: false, 
            default: 'Columnas visibles en orden',
        },
        hide_columns_header: {
            type: String,
            required: false, 
            default: 'Columnas ocultas',
        },
        show_columns: {
            type: Array,
            required: true,
        },
        hide_columns: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: '500px',
        },
    },
    data() {
        return {
            show_copy: [],
            hide_copy: [],
        }
    },
    components: {
        AppModalPrompt,
        draggable,
        AppModalCol,
        AppModalContainer,
        AppModalRow,
    },
    mounted() {
        this.show_copy = this.show_columns;
        this.hide_copy = this.hide_columns;
    },
}
</script>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: #663399;
    }
    .primary-border {
        border-color: #663399 !important;
    }
    .draggable-item {
        border-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .text-color {
        color: #663399;
    }

    .y-scroll {
        overflow-y: scroll;
        height: 300px;
    }
</style>
